<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt="" width="25" height="25" />
      <p class="title-bk">ブランド登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'brand' }">戻る</router-link>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <a href="/pdf/form_brand.pdf" target="_blank">フォームの説明を確認</a>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submitForm)" ref="form">
          <table class="table table-form">
            <tbody>
              <ChoiceField
                v-model="choiceFieldMultiModels"
                extraRules="required_select"
                label="法人名（法人ID）"
                placeholder="選択して下さい"
                resourceType="corporation"
                modelFieldName="corporation"
                :choiceDisable="loggedInAsCorporation"
                :formData="currentBrand"
              />
              <IdInputField
                v-model="currentBrand.uid"
                extraRules="required"
                label="ブランドID"
                placeholder="半角英数字で入力してください（-、_は可）"
                inputClass="col-lg-6"
                resourceType="brand"
              />
              <PasswordField vid="password" v-model="currentBrand.password" extraRules="required" />
              <PasswordField
                v-model="verifyPassword"
                extraRules="required|verify_password:password"
                label="パスワード（確認）"
              />
              <br />
              <TextField v-model="currentBrand.name" label="ブランド名" extraRules="required" />
              <TextField
                v-model="currentBrand.nameReading"
                label="ブランド名(フリガナ)"
                placeholder="全角カタカナ"
                extraRules="required"
              />
              <PostalCodeField
                v-model="currentBrand.postalCode"
                @fillAddresses="fillAddresses($event)"
                extraRules="required"
                inputClass="col-lg-4"
              />
              <TextField
                v-model="currentBrand.state"
                extraRules="required"
                label="都道府県 市区町村"
                placeholder="例）京都府京都市中京区笋町"
              />
              <TextField
                v-model="currentBrand.address"
                extraRules="required"
                label="番地・建物名"
                placeholder="例）688 第15長谷ビル5F"
              />
              <TextField
                v-model="currentBrand.phone"
                extraRules="phone_number|required"
                label="電話番号"
                placeholder="例）075-708-8100"
              />
              <TextField
                v-model="currentBrand.fax"
                extraRules="phone_number"
                label="FAX番号"
                placeholder="例）075-708-8101"
              />
              <TextField
                v-model="currentBrand.email"
                extraRules="email"
                label="メールアドレス"
                placeholder="例）sample@tamaishiki.com"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">確認</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import EventBus from '@/helpers/EventBus.js';
import TextField from '@/components/forms/TextField.vue';
import PostalCodeField from '@/components/forms/PostalCodeField.vue';
import PasswordField from '@/components/forms/PasswordField.vue';
import ChoiceField from '@/components/forms/ChoiceField.vue';
import IdInputField from '@/components/forms/IdInputField.vue';
import { basicCorporationNameIdPresent } from '@/presenters/fields';

export default {
  data() {
    return {
      verifyPassword: '',
      currentBrand: {},
    };
  },
  components: {
    ValidationObserver,
    TextField,
    PostalCodeField,
    PasswordField,
    IdInputField,
    ChoiceField,
  },
  computed: {
    choiceFieldMultiModels() {
      if (this.currentBrand.corporation) {
        return basicCorporationNameIdPresent(this.currentBrand.corporation);
      }
      return '';
    },
    ...mapState(['brand']),
    ...mapState(['corporation']),
    ...mapState('form', ['prevFormData']),
    ...mapGetters('auth', ['loggedInAsCorporation']),
  },
  mounted() {
    EventBus.$on('SET_USER_PROFILE', this.setCurrentRoleHandler);
  },
  created() {
    this.currentBrand = this.createFreshBrandObject();
  },
  beforeDestroy() {
    EventBus.$off('SET_USER_PROFILE', this.setCurrentRoleHandler);
  },
  methods: {
    createFreshBrandObject() {
      if (this.brand.editingBrand) {
        this.$logger.debug('Editing old Brand with ID ' + this.brand.editingBrand);
        return this.brand.editingBrand;
      } else if (this.prevFormData) {
        this.$logger.debug('Restoring previous form data', this.prevFormData);
        return this.prevFormData;
      } else {
        let newBrand = {
          corporation: null,
          uid: '',
          name: '',
          nameReading: '',
          postalCode: '',
          state: '',
          address: '',
          phone: '',
          email: null,
          password: '',
        };
        if (this.loggedInAsCorporation) {
          newBrand['corporation'] = this.corporation.corporation;
        }
        return newBrand;
      }
    },
    submitForm() {
      this.$logger.debug('Started Adding: ' + JSON.stringify(this.currentBrand));
      this.startEditingBrand(this.currentBrand);
      this.$router.push({ name: 'brand-confirm' });
    },
    fillAddresses(addressComponents) {
      this.$logger.debug('addressComponents', addressComponents);
      this.currentBrand.state = addressComponents.city_state;
      this.currentBrand.address = addressComponents.address;
    },
    setCurrentRoleHandler(payload) {
      if (this.loggedInAsCorporation) {
        this.currentBrand.corporation = payload.data;
      }
    },
    ...mapActions('brand', ['startEditingBrand']),
  },
};
</script>
<style scoped>
.btn-confirm {
  margin-left: 0px;
}
</style>
